<div>
    <div class="row" style="margin:0px" >
        <span class="modal-sub-header">Options:</span>

        <div>
            <label class="checkbox">
                <input type="checkbox"
                       name="includeGabapentin"
                       [ngModel]="includeGabapentin"
                       (ngModelChange)="includeGabapentinChanged($event)">
                    <span></span>
                    <span  class="checkbox-label">
                        Include Gabapentin
                    </span>                    
            </label>
        </div>
    </div>
    <div class="row" style="margin:0px" >
        <span class="modal-sub-header">Order Type:</span>
        
        <div *ngFor="let orderType of orderTypes">
            <label class="radio">
                <input type="radio" 
                        name="orderType"
                        [ngModel]="selectedOrderType"
                        (ngModelChange)="selectedOrderTypeChanged($event)"
                        [value]="orderType"><span></span>
                {{getDisplayNameForEnum(orderType)}}
            </label>
        </div>
    </div>
</div>